export const FEATURE_OVERRIDE_ENABLED = 'featureOverrideEnabled';
export const FEATURE_NAVI_3 = 'navi_3';
export const FEATURE_PORSCHE_75_YEARS_LOGO = 'porsche_75_years_logo';
export const FEATURE_SHOP = 'shop';
export const FEATURE_PCOM_SEARCH = 'pcom_search';
export const FEATURE_SAVED_ITEMS = 'saved_items';
export const FEATURE_AB_TESTING = 'ab';

export const FEATURE_DEALER_SEARCH_CHINA = 'dealer_search_china';
